import {
  ApartmentOutlined,
  BankOutlined,
  BarChartOutlined,
  DollarOutlined,
  FileTextOutlined,
  IdcardOutlined,
  TeamOutlined,
  ToolOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import { NavLink } from 'react-router-dom';

import { ReactComponent as Line } from '../../assets/line.svg';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { ReactComponent as Logout } from '../../assets/logout.svg';
import { ReactComponent as Arrow } from '../../assets/menu-arrow.svg';
import { routes } from '../../routes';
import { logout } from '../../utils/logout';

import styles from './dashboardLayout.module.scss';

const Sidebar = () => {
  const items = [
    {
      key: 'admission',
      label: 'Admission',
      icon: <UserAddOutlined />,
      children: [
        {
          key: 'users',
          label: <NavLink to={routes.userMgt.users}>Applicants</NavLink>,
          icon: <Line />,
        },
        {
          key: 'requiredDocument',
          label: <NavLink to={routes.setup.requiredDocument}>Required Documents</NavLink>,
          icon: <Line />,
        },
        {
          key: 'schoolConfig',
          label: <NavLink to={routes.setup.schoolConfig}>School Feature Config</NavLink>,
          icon: <Line />,
        },
        {
          key: 'matricFormat',
          label: <NavLink to={routes.setup.matricFormat}>Matric Format</NavLink>,
          icon: <Line />,
        },
      ],
    },
    {
      key: 'academicStructure',
      label: 'Academic Structure',
      icon: <ApartmentOutlined />,
      children: [
        {
          key: 'school',
          label: <NavLink to={routes.setup.faculty}>School</NavLink>,
          icon: <Line />,
        },
        {
          key: 'department',
          label: <NavLink to={routes.setup.department}>Department</NavLink>,
          icon: <Line />,
        },
        {
          key: 'program',
          label: <NavLink to={routes.setup.program}>Program</NavLink>,
          icon: <Line />,
        },
        {
          key: 'programType',
          label: <NavLink to={routes.setup.programType}>Program Type</NavLink>,
          icon: <Line />,
        },
        {
          key: 'specialization',
          label: <NavLink to={routes.setup.specialization}>Specialization</NavLink>,
          icon: <Line />,
        },
        {
          key: 'sessionSetup',
          label: <NavLink to={routes.setup.session}>Session</NavLink>,
          icon: <Line />,
        },
        {
          key: 'applicationBatch',
          label: <NavLink to={routes.setup.applicationBatch}>Application Batch</NavLink>,
          icon: <Line />,
        },
        {
          key: 'modeOfStudy',
          label: <NavLink to={routes.setup.modeOfStudy}>Mode of Study</NavLink>,
          icon: <Line />,
        },
          {
          key: 'level',
          label: <NavLink to={routes.setup.level}>Level</NavLink>,
          icon: <Line />,
        },
        {
          key: 'tuitionYears',
          label: <NavLink to={routes.setup.tuitionYears}>Tuition Years</NavLink>,
          icon: <Line />,
        },
      ],
    },
    {
      key: 'feesFinance',
      label: 'Fees SetUp',
      icon: <DollarOutlined />,
      children: [
        {
          key: 'applicationFee',
          label: <NavLink to={routes.setup.applicationFee}>Application Fee</NavLink>,
          icon: <Line />,
        },
        {
          key: 'acceptanceFee',
          label: <NavLink to={routes.setup.acceptanceFee}>Acceptance Fee</NavLink>,
          icon: <Line />,
        },
        {
          key: 'discountFee',
          label: <NavLink to={routes.setup.discountFee}>Discount</NavLink>,
          icon: <Line />,
        },
        {
          key: 'tuitionFee',
          label: <NavLink to={routes.setup.tuitionFee}>Tuition Fee</NavLink>,
          icon: <Line />,
        },
        // {
        //   key: 'level',
        //   label: <NavLink to={routes.setup.level}>Level</NavLink>,
        //   icon: <Line />,
        // },
        // {
        //   key: 'tuitionYears',
        //   label: <NavLink to={routes.setup.tuitionYears}>Tuition Years</NavLink>,
        //   icon: <Line />,
        // },
      ],
    },
    {
      key: 'programmeContent',
      label: 'Programme Content',
      icon: <FileTextOutlined />,
      children: [
        {
          key: 'readMoreProgram',
          label: <NavLink to={routes.setup.readMoreProgram}>Read More – Program</NavLink>,
          icon: <Line />,
        },
        {
          key: 'readMoreCourse',
          label: <NavLink to={routes.setup.readMoreCourse}>Read More – Course</NavLink>,
          icon: <Line />,
        },
        {
          key: 'admissionRequirements',
          label: <NavLink to={routes.setup.readMoreAdmissionRequirement}>Admission Requirements</NavLink>,
          icon: <Line />,
        },
        {
          key: 'careerProspects',
          label: <NavLink to={routes.setup.careerProspects}>Career Prospects</NavLink>,
          icon: <Line />,
        },
        {
          key: 'curriculum',
          label: <NavLink to={routes.setup.curriculum}>Curriculum</NavLink>,
          icon: <Line />,
        },
        {
          key: 'scholarship',
          label: <NavLink to={routes.setup.scholarship}>Scholarship</NavLink>,
          icon: <Line />,
        },
        {
          key: 'accreditation',
          label: <NavLink to={routes.setup.accreditation}>Accreditation</NavLink>,
          icon: <Line />,
        },
        {
          key: 'testimonial',
          label: <NavLink to={routes.setup.testimony}>Testimonial</NavLink>,
          icon: <Line />,
        },
      ],
    },
    {
      key: 'utilities',
      label: 'Utilities SetUp',
      icon: <ToolOutlined />,
      children: [
        {
          key: 'qualificationType',
          label: <NavLink to={routes.setup.qualification}>Qualification Type</NavLink>,
          icon: <Line />,
        },
        {
          key: 'subject',
          label: <NavLink to={routes.setup.subject}>Subject</NavLink>,
          icon: <Line />,
        },
        {
          key: 'grade',
          label: <NavLink to={routes.setup.grade}>Grade</NavLink>,
          icon: <Line />,
        },
        {
          key: 'tab',
          label: <NavLink to={routes.setup.tab}>Tab</NavLink>,
          icon: <Line />,
        },
        {
          key: 'displayTab',
          label: <NavLink to={routes.setup.DisplayTabSetup}>Display Tab</NavLink>,
          icon: <Line />,
        },
         {
          key: 'schoolId',
          label: <NavLink to={routes.userMgt.addSchoolId}>Lookup Setup</NavLink>,
          icon: <Line />,
        },
      ],
    },
    {
      key: 'biodata',
      label: 'Bio-Data Setup',
      icon: <IdcardOutlined />,
      children: [
        {
          key: 'addTitle',
          label: <NavLink to={routes.setup.title}>Title</NavLink>,
          icon: <Line />,
        },
        {
          key: 'addGender',
          label: <NavLink to={routes.setup.gender}>Gender</NavLink>,
          icon: <Line />,
        },
        {
          key: 'addMaritalStatus',
          label: <NavLink to={routes.setup.maritalStatus}>Marital Status</NavLink>,
          icon: <Line />,
        },
        {
          key: 'addReligion',
          label: <NavLink to={routes.setup.religion}>Religion</NavLink>,
          icon: <Line />,
        },
        {
          key: 'addDisability',
          label: <NavLink to={routes.setup.disability}>Disability</NavLink>,
          icon: <Line />,
        },
        {
          key: 'addCountry',
          label: <NavLink to={routes.setup.country}>Country</NavLink>,
          icon: <Line />,
        },
        {
          key: 'addState',
          label: <NavLink to={routes.setup.state}>State</NavLink>,
          icon: <Line />,
        },
        {
          key: 'addLGA',
          label: <NavLink to={routes.setup.lga}>LGA</NavLink>,
          icon: <Line />,
        },
      ],
    },
    {
      key: 'schoolInfo',
      label: 'School Information',
      icon: <BankOutlined />,
      children: [
        {
          key: 'institution',
          label: <NavLink to={routes.setup.institution}>Institution</NavLink>,
          icon: <Line />,
        },
        {
          key: 'exploreProgrammes',
          label: <NavLink to={routes.setup.exploreProgrammes}>Explore Programmes</NavLink>,
          icon: <Line />,
        },
        {
          key: 'aboutUs',
          label: <NavLink to={routes.setup.aboutUs}>About Us</NavLink>,
          icon: <Line />,
        },
        {
          key: 'whyUs',
          label: <NavLink to={routes.setup.whyUs}>Why Us</NavLink>,
          icon: <Line />,
        },
        {
          key: 'faq',
          label: <NavLink to={routes.setup.faq}>FAQ</NavLink>,
          icon: <Line />,
        },
        {
          key: 'newsAndEvents',
          label: <NavLink to={routes.setup.newsAndEvents}>News & Events</NavLink>,
          icon: <Line />,
        },
        {
          key: 'history',
          label: <NavLink to={routes.setup.history}>History</NavLink>,
          icon: <Line />,
        },
        {
          key: 'schoolMgt',
          label: <NavLink to={routes.setup.schoolMgt}>School Management</NavLink>,
          icon: <Line />,
        },
        {
          key: 'schoolInfoTemplate',
          label: <NavLink to={routes.setup.schoolInfo}>Template</NavLink>,
          icon: <Line />,
        },
        {
          key: 'socialMedia',
          label: <NavLink to={routes.setup.socialMedia}>Social Media</NavLink>,
          icon: <Line />,
        },
        {
          key: 'studentLife',
          label: <NavLink to={routes.setup.studentLife}>Student Life</NavLink>,
          icon: <Line />,
        },
      ],
    },
    {
      key: 'userManagement',
      label: 'User Management',
      icon: <TeamOutlined />,
      children: [
        {
          key: 'admin-users',
          label: <NavLink to={routes.userMgt.adminUsers}>Admin Users</NavLink>,
          icon: <Line />,
        },
        {
          key: 'permissions',
          label: <NavLink to={routes.userMgt.permissions}>Permissions</NavLink>,
          icon: <Line />,
        },
        {
          key: 'privileges',
          label: <NavLink to={routes.userMgt.privileges}>Privileges</NavLink>,
          icon: <Line />,
        },
        {
          key: 'emailTemplates',
          label: <NavLink to={routes.userMgt.emailTemplates}>Email Templates</NavLink>,
          icon: <Line />,
        },
        {
          key: 'contactUs',
          label: <NavLink to={routes.userMgt.contactUs}>Contact Feedback</NavLink>,
          icon: <Line />,
        },
        // {
        //   key: 'schoolId',
        //   label: <NavLink to={routes.userMgt.addSchoolId}>Lookup Setup</NavLink>,
        //   icon: <Line />,
        // },
      ],
    },
    {
      key: 'reports',
      label: 'Reports',
      icon: <BarChartOutlined />,
      children: [
        {
          key: 'paymentReport',
          label: <NavLink to={routes.reports.paymentReport}>Payment Report</NavLink>,
          icon: <Line />,
        },
        {
          key: 'applicantReport',
          label: <NavLink to={routes.reports.applicantReport}>Applicant Report</NavLink>,
          icon: <Line />,
        },
      ],
    },
  ];

  return (
    <>
      <section>
        <div className={styles.wrapper}>
          <Logo />
        </div>

        <div className={styles.menuItems}>
          <Menu
            items={items}
            mode="inline"
            inlineIndent={0}
            defaultOpenKeys={['admission']}
            expandIcon={(info) => <Arrow className={info.isOpen ? 'rotate' : ''} />}
          />
        </div>
      </section>

      <button className={styles.logout} onClick={logout}>
        <Logout />
        <p className={styles.end}>Logout</p>
      </button>
    </>
  );
};

export default Sidebar;
